<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'IP Filter'"></Teranet-PageTitle>
    <form [formGroup]="ipFilteringForm" #downloadform="ngForm" novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'Lookup IP Filter'" [IconName]="'search'"></Teranet-ClientTitle>
            <div fxLayout="row wrap" fxLayoutAlign="end">
              <div class="icon-button">
                <button mat-button (click)="onEdit(clientInfos, null)">
                  <div class="btnicon"><fa-icon icon="plus" id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon></div>
                  <div class="btntext">Add</div>
                </button>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Corporation </mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required
                              placeholder="--Please Select--"
                              formControlName="clientInfoId"
                              (selectionChange)="onClientChange()">
                    <mat-option *ngFor="let ci of clientInfos" [value]="ci.id">
                      {{ ci.description }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="ipFilteringForm.get('clientInfoId').hasError('required')">
                    {{ ipFilteringEditErrorMessage.CORPORATION_REQUIRED }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="end">
              <button mat-raised-button class="plain-button-lg" (click)="onClearCriteria()">Clear Criteria</button>
              <button mat-raised-button class="theme-button-lg" (click)="onSearch()">Lookup</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <Teranet-CustomizedGrid [data]="ipFilterings"
                            [gridName]="'ip-filtering'"
                            [gridSettings]="gridSettings"
                            [initialGridSettings]="GridDefaultSettings()"
                            [isFinishLoading]="true"
                            [pageName]="'ip-filtering'"></Teranet-CustomizedGrid>
  </div>
</div>
